import { envConfig } from '../../../../env';
import { Post } from '@/service/request/server';

let baseUrl = envConfig.formalServer + '/cotton/api';

export function insertApiInfo(data) {
    return Post(baseUrl + '/insertApiInfo', data);
}

export function updateApiInfo(data) {
    return Post(baseUrl + '/updateApiInfo', data);
}

export function deleteApiInfo(data) {
    return Post(baseUrl + '/deleteApiInfo', data);
}

export function queryApiInfoList(data) {
    return Post(baseUrl + '/queryApiInfoList', data);
}
